<ng-container *ngIf="(isMobile$ | async) === false; else hotelsMobile">
  <div class="home-hotels-container">
    <h1>{{ 'HOTELS_MODULE.HOME.TITLE' | transloco }}</h1>
    <app-hotel-search
      [source]="source"
      [searchType]="searchType">
    </app-hotel-search>
    <div class="home-container" *ngIf="homeData$ | async as homeData">
      <app-home [source]="source"></app-home>
    </div>
  </div>
</ng-container>
<ng-template #hotelsMobile>
  <div class="hotels-home" [class.showInput]="showInput" *ngIf="!isByHours; else searchByhours">
    <app-hotel-search
      [source]="source"
      [isMobile]="isMobile$ | async"
      [loadDefaultplaces]="loadDefaultplaces"
      (showRoomsComponent)="showRoomsEdition()"
      (showDestination)="showDestination($event)"
      (showMobileCalendarEvent)="showMobileCalendar($event)">
    </app-hotel-search>
  </div>
  <ng-template #searchByhours>
    <app-byhours-search
      [source]="source"
      [isMobile]="isMobile$ | async"
      [loadDefaultplaces]="loadDefaultplaces"
      (showDestination)="showDestination($event)"
      (showMobileCalendarEvent)="showMobileCalendar($event)">
    </app-byhours-search>
  </ng-template>
  
</ng-template>

<router-outlet name="search"></router-outlet>